import React from 'react';
import { Loader2 } from 'lucide-react';

interface PageLoadingProps {
  message?: string;
}

export function PageLoading({ message = 'Carregando dados...' }: PageLoadingProps) {
  return (
    <div className="w-full min-h-[300px] flex flex-col items-center justify-center p-6 gap-3 select-none">
      <div className="relative flex items-center justify-center">
        <Loader2 className="w-8 h-8 text-indigo-600 animate-spin" />
        <div className="absolute w-2 h-2 rounded-full bg-indigo-600" />
      </div>
      <p className="text-sm font-semibold text-slate-500 animate-pulse mt-1">{message}</p>
    </div>
  );
}

export default PageLoading;
